import { StratumService, WINDOW_DEBUG_FLAG_KEY } from '@cof/stratum';
import { PRODUCT_NAME, TAG_CATALOG, PRODUCT_VERSION } from '@cof/tag-catalog-refi-user-entry-mfe';
import { RefiSharedAnalyticsService } from '@cof/refi-web-sdk';
import { RefiNewRelicPlugin } from '../utils/new-relic-plugin.js';
import { REFI_WEB_UI_CONST } from './constants.js';

export const stratum = new StratumService(TAG_CATALOG, {
  productName: PRODUCT_NAME,
  productVersion: PRODUCT_VERSION,
  plugins: [RefiNewRelicPlugin()],
});

export const refiSharedAnalyticsService = new RefiSharedAnalyticsService(stratum, REFI_WEB_UI_CONST.isProd());

if (window.location.host !== 'refi-web-apply.cloud.capitalone.com' || window.location.host !== 'autorefi.capitalone.com') {
  window[WINDOW_DEBUG_FLAG_KEY] = true;
  stratum.addEventListener(event => {
    // eslint-disable-next-line no-console
    console.log('Stratum Event Received', event);
  });
}
